import { QUERY_RESPONSE_RECEIVED } from '@web-platform/shared-universal-constants/src/network';
import { ADS_CAPABILITY_EXPLORE } from '@web-platform/shared-universal-types/src/network/requestTypes';

import { transformAdsCapabilityResponseToFilteredExploreAirline } from './transform';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { FilteredExploreAirlineState } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/filteredExploreAirline';

const INITIAL_STATE: FilteredExploreAirlineState = {
  byId: {},
};

const filteredExploreAirlineReducer = (
  state: FilteredExploreAirlineState = INITIAL_STATE,
  action: Action,
): FilteredExploreAirlineState => {
  switch (action.type) {
    case QUERY_RESPONSE_RECEIVED: {
      if (action.payload.type !== ADS_CAPABILITY_EXPLORE || action.payload.response.error) {
        return state;
      }
      return {
        byId: transformAdsCapabilityResponseToFilteredExploreAirline(action.payload.response.body),
      };
    }
    default:
      return state;
  }
};

export default filteredExploreAirlineReducer;
